import { $ } from './dom';

const SHEETS = ['shMine', 'shAccount', 'shShare', 'shSaveTpl', 'shExport', 'shTemplates', 'shElements', 'shText', 'shUpload', 'shLayers', 'shMore', 'shDict', 'shPages',
  'shVImport', 'shVPrep', 'shVTrim', 'shVSound', 'shVVoice', 'shVFade', 'shVExport', 'shVStore', 'shVSlots', 'shVTexts', 'shVMusicLib', 'shFonts', 'shPhoto', 'shAiImage', 'shAiTpl', 'shFlow', 'shDoc'] as const;
export type SheetId = typeof SHEETS[number];

const onOpen = new Map<SheetId, () => void>();
let onAnyChange: (open: SheetId | null) => void = () => {};

/** Called whenever a panel opens or everything closes (used to keep the artboard clear of side panels). */
export const onSheetChange = (fn: (open: SheetId | null) => void) => { onAnyChange = fn; };

/** Register what to refresh when a panel opens. */
export const whenOpened = (id: SheetId, fn: () => void) => onOpen.set(id, fn);
export const isOpen = (id: SheetId) => !$(id).hidden;

function markTabs(open: SheetId | null) {
  // tabs that open a panel; เครื่องมือ (src/ui/drawTools.ts) keeps its own state
  document.querySelectorAll<HTMLButtonElement>('#tabs .tab[data-sheet]').forEach(t => {
    t.setAttribute('aria-pressed', String(t.dataset.sheet === open));
  });
}

function hideAll() {
  SHEETS.forEach(s => { $(s).hidden = true; });
  markTabs(null);
}

export function closeSheets() {
  hideAll();
  onAnyChange(null);
}

/** Open a panel (closing any other); tapping the open one again closes it. */
export function toggleSheet(id: SheetId) {
  const willOpen = $(id).hidden;
  hideAll();
  if (!willOpen) { onAnyChange(null); return; }
  $(id).hidden = false;
  markTabs(id);
  onOpen.get(id)?.();
  onAnyChange(id);
}

/** Open a panel without the toggle behaviour (used for links between panels). */
export function openSheet(id: SheetId) {
  if (isOpen(id)) return;
  toggleSheet(id);
}

export function initSheets() {
  document.querySelectorAll<HTMLButtonElement>('[data-close]').forEach(b => {
    b.onclick = () => closeSheets();
  });
  document.querySelectorAll<HTMLButtonElement>('#tabs .tab[data-sheet]').forEach(t => {
    t.setAttribute('aria-pressed', 'false');
    t.onclick = () => toggleSheet(t.dataset.sheet as SheetId);
  });
}
